var exports = {
  "kL": "xfd349460--ce9449--container",
  "VY": "xfd349460--ce9449--info-block",
};

module.exports = exports;
